import { FooterStyled } from './footer.styled';
import i18n from '../../../../../translations/strings';
import { SvgImage, SvgType } from '../../../../../components/base/svg/svg';
import { useEffect, useRef } from 'react';

export interface FooterLandingPageProps {
  handleRefFooter: (ref: any) => void;
}

const FooterLandingPage = (props: FooterLandingPageProps) => {
  const footerRef = useRef(null);

  useEffect(() => {
    props.handleRefFooter(footerRef);
  }, [footerRef]);
  return (
    <FooterStyled.Container ref={footerRef}>
      <FooterStyled.FooterLogo>
        {i18n.t('landing.landingText')}
      </FooterStyled.FooterLogo>
      <FooterStyled.FooterContentContainer container>
        <FooterStyled.FooterContent item xs={12} md={12}>
          <FooterStyled.Email
            href={`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}`}
          >
            {process.env.REACT_APP_EMAIL_ADDRESS}
          </FooterStyled.Email>
        </FooterStyled.FooterContent>
      </FooterStyled.FooterContentContainer>
      <FooterStyled.FooterBottom>
        {i18n.t('landing.copyright')}
      </FooterStyled.FooterBottom>
    </FooterStyled.Container>
  );
};

export default FooterLandingPage;
